import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { APP_PATHS } from "../../../constants/paths";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import emptyIcon from "../../../assets/icons/empty.svg";
import classes from "./EmptyContent.module.css";

const EmptyContent = (props) => {
  const { className, message, withAction } = props;

  return (
    <div className={classNames(classes["empty-content"], className)}>
      <div
        className={classNames(
          classes["empty-content__icon-wrapper"],
          "icon-wrapper"
        )}
      >
        <img
          src={emptyIcon}
          alt="empty"
          className={classNames(classes["empty-content__icon"], "icon")}
        />
      </div>
      <p className={classNames(classes["empty-content__message"], "message")}>
        {message}
      </p>
      {withAction && (
        <Link to={APP_PATHS.HOME.url}>
          <PrimaryButton className={classes["empty-content__action-btn"]}>
            تسوق الأن
          </PrimaryButton>
        </Link>
      )}
    </div>
  );
};

export default EmptyContent;

EmptyContent.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  withAction: PropTypes.bool,
};
